import { Box, Stack, TableRow } from '@mui/material';
import React, { memo } from 'react';
import ErrorBoundary from '../../../components/material-ui/error_boundary/ErrorBoundary';
import MyTableCell from '../../../components/material-ui/adaptive/MyTableCell';
import BannerTableShowFile from './BannerTableShowFile';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import { IconCircleFilled } from '@tabler/icons-react';
import BtnEdit from '../../../components/bonus/ui/BtnEdit';
import BtnTrash from '../../../components/bonus/ui/BtnTrash';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { getOnlyData } from '../../../utils';
import useColor from '../../../hooks/site/useColor';
import { useNavigate } from 'react-router';

const ListBannersTableRow = memo(
  ({ banner, setSelectBanner, setOpenDelete, groupId, stickyCell }) => {
    const { t } = useTranslation();
    const { success, error } = useColor();
    const navigate = useNavigate();

    const successColor = success.main;
    const errorColor = error.main;

    const getLinkBanner = (banner) => {
      if (banner.makeBotLink) return t('Link to bot');
      if (banner.gameId) {
        let gameName = '';
        if (banner.gameInfo) gameName = `${banner.gameInfo.name} (${banner.gameInfo.providerName})`;
        return `${t('Launching the game')} ${gameName}`;
      }
      return banner.externalUrl || banner.relativeUrl;
    };

    const linkBanner = getLinkBanner(banner);
    const now = dayjs();
    const from = dayjs(banner.dateFrom);
    const to = dayjs(banner.dateTo);

    const isActive = now.isAfter(from) && now.isBefore(to);

    return (
      <ErrorBoundary>
        <TableRow>
          <MyTableCell isLess sx={{ maxHeight: 200 }}>
            {banner.name}
          </MyTableCell>
          <MyTableCell isLess type="numeric">
            {banner.position}
          </MyTableCell>
          <MyTableCell isLess>
            <Stack display={'flex'} flexDirection={'row'} gap={1} alignItems={'center'}>
              {banner.language}
            </Stack>
          </MyTableCell>
          <MyTableCell isLess>{linkBanner}</MyTableCell>
          <MyTableCell isLess>
            <Box sx={{ maxHeight: 200, maxWidth: 350, overflow: 'auto' }}>
              <div dangerouslySetInnerHTML={{ __html: banner.bannerText }} />
            </Box>
          </MyTableCell>
          <MyTableCell isLess>
            <Stack
              display={'flex'}
              alignItems="center"
              justifyContent={'center'}
              sx={{ minWidth: 80, maxWidth: 150, maxHeight: 120 }}
              onClick={() => setSelectBanner(banner.fileUrl)}>
              <BannerTableShowFile fileUrl={banner.fileUrl} />
            </Stack>
          </MyTableCell>
          <MyTableCell isLess>
            <Stack
              display={'flex'}
              alignItems="center"
              justifyContent={'center'}
              sx={{ minWidth: 60, maxWidth: 150, maxHeight: 120 }}
              onClick={() => setSelectBanner(banner.mobileFileUrl)}>
              <BannerTableShowFile fileUrl={banner.mobileFileUrl} />
            </Stack>
          </MyTableCell>
          <MyTableCell isLess>
            <ShowContainer condition={isActive}>
              <IconCircleFilled
                height={14}
                fill={isActive ? successColor : errorColor}
                color={isActive ? successColor : errorColor}
                style={{ color: isActive ? successColor : errorColor }}
              />
              <br />
            </ShowContainer>
            {getOnlyData(dayjs(banner.dateFrom), '', 'DD.MM.YYYY')} -
            <br />
            {getOnlyData(dayjs(banner.dateTo), '', 'DD.MM.YYYY')}
          </MyTableCell>
          <MyTableCell isSmall sx={stickyCell}>
            <Stack display={'flex'} gap={1} alignItems={'center'} flex>
              <BtnEdit onEditClick={() => navigate(`/slider-banners/${groupId}/${banner.id}`)} />
              <BtnTrash onDelete={() => setOpenDelete(banner.id)} />
            </Stack>
          </MyTableCell>
        </TableRow>
      </ErrorBoundary>
    );
  },
  (prev, current) => prev.banner.id == current.banner.id
);

export default ListBannersTableRow;
